import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { message } from 'antd';
import {
  get_all_emp_tasks,
  notifications,
  release_task,
  updateNotification
} from './api';

const initialState = {
  loading: false,
  notifications: [],
  notificationCounts: 0,
  user: null
};

const actions = {
  getNotifications: 'notification/getNotifications',
  markAsSeen: 'notification/markAsSeen'
};

export const getNotifications = createAsyncThunk(
  actions.getNotifications,
  async (payload) => {
    const response = await notifications('get-recent-notifications', payload);

    return response;
  }
);

export const markNotificationsAsSeen = createAsyncThunk(
  actions.markAsSeen,
  async (payload) => {
    const response = await updateNotification(
      'notifications-mark-seen',
      payload
    );

    return response;
  }
);

export const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    receiveNotification: (state, action) => {
      const { data, unreadCount } = action.payload;
      state.notifications = data;
      state.notificationCounts = unreadCount;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getNotifications.pending, (state) => {
        state.loading = true;
      })
      .addCase(getNotifications.fulfilled, (state, action) => {
        state.loading = false;

        const { success, message: msg, data, unreadCount } = action.payload;
        if (success) {
          state.notifications = data;
          state.notificationCounts = unreadCount;
        } else {
          message.error(msg);
        }
      })
      .addCase(getNotifications.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.loading = false;

        message.error(msg);
      });

    builder
      .addCase(markNotificationsAsSeen.pending, (state) => {
        state.loading = true;
      })
      .addCase(markNotificationsAsSeen.fulfilled, (state, action) => {
        state.loading = false;

        const { success, message: msg } = action.payload;
        if (!success) {
          message.error(msg);
        }
      })
      .addCase(markNotificationsAsSeen.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.loading = false;

        message.error(msg);
      });
  }
});

export const { receiveNotification } = notificationSlice.actions;

export const selectNotificationSlice = (state) => {
  return state.notification;
};

export default notificationSlice.reducer;
